import BuyCrypto from "@/components/landing/homeFive/BuyCrypto";
import HowItsWork from "@/components/landing/homeFive/HowItsWork";
import Banner from "@/components/landing/homeSix/Banner";
import BusinessAndCommercial from "@/components/landing/homeSix/BusinessAndCommercial";
import Pricing from "@/components/landing/homeSix/Pricing";
import WhatWeOffer from "@/components/landing/homeSix/WhatWeOffer";
import WhatYouNeed from "@/components/landing/homeSix/WhatYouNeed";
import Testimonials from "@/components/landing/homeThree/Testimonials";

export default function HomeSix() {
  return (
    <>
      {/* Banner section */}
      <Banner />

      {/* Business And Commercial section */}
      <BusinessAndCommercial />

      {/* What You Need section */}
      <WhatYouNeed />

      {/* Pricing section */}
      <Pricing />

      {/* What We Offer section */}
      <WhatWeOffer />

      {/* How Its Work section */}
      <HowItsWork />

      {/* Buy Crypto section */}
      <BuyCrypto />

      {/* Testimonials section */}
      <Testimonials />
    </>
  );
}
